import { containerCls, iconCls } from './atom.scrambled.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Scrambled() {
  return /*#__PURE__*/jsx("div", {
    className: containerCls,
    children: /*#__PURE__*/jsx("svg", {
      className: iconCls,
      version: "1.1",
      viewBox: "0 0 28.1 38.8",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsxs("g", {
        children: [/*#__PURE__*/jsx("path", {
          d: "M7,13.5c0.3,0,0.5-0.2,0.5-0.5v-1.7C7.8,11.2,8,10.9,8,10.5c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,0.4,0.2,0.7,0.5,0.8V13C6.5,13.3,6.7,13.5,7,13.5z M7,10.5C7,10.5,7,10.5,7,10.5C7,10.5,7,10.5,7,10.5l-0.5,0L7,10.5z"
        }), /*#__PURE__*/jsx("path", {
          d: "M13,8v4.5c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-5C14,7.2,13.8,7,13.5,7H12V5c0-2.8-2.2-5-5-5S2,2.2,2,5v2H0.5C0.2,7,0,7.2,0,7.5v10C0,17.8,0.2,18,0.5,18h1C1.8,18,2,17.8,2,17.5S1.8,17,1.5,17H1V8H13z M3,5c0-2.2,1.8-4,4-4s4,1.8,4,4v2H3V5z"
        }), /*#__PURE__*/jsx("path", {
          d: "M27.5,14.7h-23c-0.3,0-0.6,0.3-0.6,0.6v23c0,0.3,0.3,0.6,0.6,0.6h23c0.3,0,0.6-0.3,0.6-0.6v-23C28.1,14.9,27.8,14.7,27.5,14.7z M26.9,37.7H5.1V15.8h21.9V37.7z"
        }), /*#__PURE__*/jsx("path", {
          d: "M11.5,31.9c2.1,0.1,6.8,0.1,8.9,0c2.3-0.2,2.6-1.5,2.6-5.2c0-3.6-0.3-5-2.6-5.2c-2.1-0.1-6.8-0.1-8.9,0C9.2,21.7,9,23.1,9,26.7C9,30.3,9.2,31.7,11.5,31.9z M13.3,23.3l6.8,3.4l-6.8,3.4V23.3z"
        })]
      })
    })
  });
}

export { Scrambled };
//# sourceMappingURL=atom.scrambled.js.map
